import React, { ReactNode, useState } from 'react';
import dayjs from 'dayjs';

import { FormComponent } from 'components';
import { useInfiniteScroll } from 'hooks';
import { CollectionQuery } from 'queries';
import * as M from 'styles/mobile';
import { SearchCollectionsFilterType } from 'types';
import { getTypeText } from '../utils';
import * as S from './style';

interface Props {
  title?: ReactNode;
}

function MobileList({ title }: Props) {
  const [filter, setFilter] = useState<SearchCollectionsFilterType>({});

  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    CollectionQuery.useGetInfinite(filter);
  const sentinelRef = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  const collections = data ?? [];

  return (
    <>
      <div css={M.stickyTop}>
        {title}
        <FormComponent.Form
          submit={(d: SearchCollectionsFilterType) =>
            setFilter({ title: d.title || undefined })
          }
        >
          <FormComponent.SearchInput
            name="title"
            placeholder="타이틀로 검색해주세요"
          />
        </FormComponent.Form>
      </div>
      <div css={M.list}>
        {collections.map((collection) => (
          <div key={collection.id} css={M.listItemStatic}>
            <div css={M.listRow}>
              <p css={S.title}>{collection.name}</p>
              <span css={M.listDate}>
                {dayjs(collection.createdAt).format('YYYY-MM-DD')}
              </span>
            </div>
            <p css={S.meta}>
              {getTypeText(collection.type)}
              {collection.title && ` (${collection.title})`}
            </p>
          </div>
        ))}
        {!isLoading && collections.length === 0 && (
          <p css={M.empty}>검색 결과가 없습니다</p>
        )}
        {isFetchingNextPage && <p css={M.empty}>불러오는 중...</p>}
      </div>
      <div ref={sentinelRef} css={M.sentinel} />
    </>
  );
}

export default MobileList;
